import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-212" data-mp="3gitk6io2w77m">{children}</div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.28,
    delay,
    ease: EASE
  }} className={className} data-id="element-213" data-mp="2jr80uu1ea7sg">
      {children}
    </motion.div>;
}